//
// Action Types
const FETCH_CORREIOS_REQUEST = 'FETCH_CORREIOS_REQUEST'
const FETCH_CORREIOS_SUCCESS = 'FETCH_CORREIOS_SUCCESS'
const FETCH_CORREIOS_FAILURE = 'FETCH_CORREIOS_FAILURE'

const DOWNLOAD_CORREIOS_SPREADSHEET_REQUEST = 'DOWNLOAD_CORREIOS_SPREADSHEET_REQUEST'
const IMPORT_CORREIOS_CSV_REQUEST = 'IMPORT_CORREIOS_CSV_REQUEST'

export const FETCH_SHIPMENTS_REQUEST = 'FETCH_SHIPMENTS_REQUEST';
export const FETCH_SHIPMENTS_SUCCESS = 'FETCH_SHIPMENTS_SUCCESS';
export const FETCH_SHIPMENTS_FAILURE = 'FETCH_SHIPMENTS_FAILURE';

export const IMPORT_CSV_REQUEST = 'IMPORT_CSV_REQUEST';
export const IMPORT_CSV_SUCCESS = 'IMPORT_CSV_SUCCESS';
export const IMPORT_CSV_FAILURE = 'IMPORT_CSV_FAILURE';

export const DELETE_SHIPMENTS_REQUEST = 'DELETE_SHIPMENTS_REQUEST';
export const DELETE_SHIPMENTS_SUCCESS = 'DELETE_SHIPMENTS_SUCCESS';
export const DELETE_SHIPMENTS_FAILURE = 'DELETE_SHIPMENTS_FAILURE';

export const SEND_MESSAGE_REQUEST = 'SEND_MESSAGE_REQUEST';
export const SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS';
export const SEND_MESSAGE_FAILURE = 'SEND_MESSAGE_FAILURE';

export const CANCEL_MESSAGE_REQUEST = 'CANCEL_MESSAGE_REQUEST';
export const CANCEL_MESSAGE_SUCCESS = 'CANCEL_MESSAGE_SUCCESS';
export const CANCEL_MESSAGE_FAILURE = 'CANCEL_MESSAGE_FAILURE';

//
// Actions
export const actions = {
  fetchCorreios: (page, itemsPerPage, filters, callback) => ({
    type: FETCH_CORREIOS_REQUEST,
    page,
    itemsPerPage,
    filters,
    callback,
  }),
  downloadSpreadsheet: (filters, callback) => ({
    type: DOWNLOAD_CORREIOS_SPREADSHEET_REQUEST,
    filters,
    callback,
  }),
  importCSV: (file, templateBotMaker, callback) => ({
    type: IMPORT_CORREIOS_CSV_REQUEST,
    file,
    templateBotMaker,
    callback,
  }),
  // Adicionando novas actions para centralizar no Redux
  sendMessage: (ids) => sendMessageRequest(ids),
  cancelMessage: (ids) => cancelMessageRequest(ids),
  deleteShipments: (ids) => deleteShipmentsRequest(ids),
  importCsv: (data) => importCsvRequest(data),
}

// Action Creators
export const fetchShipmentsRequest = (filters) => ({
  type: FETCH_SHIPMENTS_REQUEST,
  payload: filters
});

export const fetchShipmentsSuccess = (data) => ({
  type: FETCH_SHIPMENTS_SUCCESS,
  payload: data
});

export const fetchShipmentsFailure = (error) => ({
  type: FETCH_SHIPMENTS_FAILURE,
  payload: error
});

export const importCsvRequest = (data) => ({
  type: IMPORT_CSV_REQUEST,
  payload: data
});

export const importCsvSuccess = (data) => ({
  type: IMPORT_CSV_SUCCESS,
  payload: data
});

export const importCsvFailure = (error) => ({
  type: IMPORT_CSV_FAILURE,
  payload: error
});

export const deleteShipmentsRequest = (ids) => ({
  type: DELETE_SHIPMENTS_REQUEST,
  payload: ids
});

export const deleteShipmentsSuccess = (data) => ({
  type: DELETE_SHIPMENTS_SUCCESS,
  payload: data
});

export const deleteShipmentsFailure = (error) => ({
  type: DELETE_SHIPMENTS_FAILURE,
  payload: error
});

export const sendMessageRequest = (ids) => ({
  type: SEND_MESSAGE_REQUEST,
  payload: ids
});

export const sendMessageSuccess = (data) => ({
  type: SEND_MESSAGE_SUCCESS,
  payload: data
});

export const sendMessageFailure = (error) => ({
  type: SEND_MESSAGE_FAILURE,
  payload: error
});

export const cancelMessageRequest = (ids) => ({
  type: CANCEL_MESSAGE_REQUEST,
  payload: ids
});

export const cancelMessageSuccess = (data) => ({
  type: CANCEL_MESSAGE_SUCCESS,
  payload: data
});

export const cancelMessageFailure = (error) => ({
  type: CANCEL_MESSAGE_FAILURE,
  payload: error
});

//
// Initial State
export const initialState = {
  correios: [],
  pagination: {},
  loading: false,
  error: false,
  errorMessage: '',
  shipments: [],
  total: 0,
  importLoading: false,
  importResult: null,
  deleteLoading: false,
  sendMessageLoading: false,
  cancelMessageLoading: false
}

//
// Reducer
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_CORREIOS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        errorMessage: '',
      }

    case FETCH_CORREIOS_SUCCESS:
      return {
        ...state,
        loading: false,
        correios: action.data,
        pagination: action.pagination || {},
        error: false,
        errorMessage: '',
      }

    case FETCH_CORREIOS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        errorMessage: action.errorMessage || 'Erro ao carregar correios',
      }

    case FETCH_SHIPMENTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case FETCH_SHIPMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        shipments: action.payload.data || [],
        total: action.payload.total || 0,
        error: null
      };
    
    case FETCH_SHIPMENTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    
    case IMPORT_CSV_REQUEST:
      return {
        ...state,
        importLoading: true,
        error: null,
        importResult: null // Limpar resultado anterior
      };
    
    case IMPORT_CSV_SUCCESS:
      return {
        ...state,
        importLoading: false,
        importResult: action.payload,
        error: null
      };
    
    case IMPORT_CSV_FAILURE:
      return {
        ...state,
        importLoading: false,
        error: action.payload,
        importResult: null
      };

    case DELETE_SHIPMENTS_REQUEST:
      return {
        ...state,
        deleteLoading: true,
        error: null
      };
    
    case DELETE_SHIPMENTS_SUCCESS:
      return {
        ...state,
        deleteLoading: false,
        error: null
      };
    
    case DELETE_SHIPMENTS_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        error: action.payload
      };

    case SEND_MESSAGE_REQUEST:
      return {
        ...state,
        sendMessageLoading: true,
        error: null
      };
    
    case SEND_MESSAGE_SUCCESS:
      return {
        ...state,
        sendMessageLoading: false,
        error: null
      };
    
    case SEND_MESSAGE_FAILURE:
      return {
        ...state,
        sendMessageLoading: false,
        error: action.payload
      };

    case CANCEL_MESSAGE_REQUEST:
      return {
        ...state,
        cancelMessageLoading: true,
        error: null
      };
    
    case CANCEL_MESSAGE_SUCCESS:
      return {
        ...state,
        cancelMessageLoading: false,
        error: null
      };
    
    case CANCEL_MESSAGE_FAILURE:
      return {
        ...state,
        cancelMessageLoading: false,
        error: action.payload
      };

    default:
      return state
  }
} 